import {Input} from "@headlessui/react";
import React from "react";

export default function FloatingInput({
  label,
  id,
  name,
  value,
  onChange,
  placeholder,
    disabled = false,
  darkMode = false,
  className = "",
  type = "text",
    required = false,
}) {
  return (
      <div className={`relative flex w-full`}>
          
          <label
              className={`line-clamp-1 whitespace-nowrap absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
          >
              {label}
              
              {required && (
                  <div className={`ml-1`}>
                      <div className={`flex-none rounded-full p-1 ${value ? 'bg-emerald-500/30' : 'bg-red-500/30'}`}>
                          <div className={`size-2 rounded-full ${value ? 'bg-emerald-500' : 'bg-red-500 animate-pulse'}`}/>
                      </div>
                  </div>
              )}
          
          </label>
          
          <Input
              type={type}
              id={id}
              name={name}
              value={value}
              required={required}
              onChange={onChange}
              disabled={disabled}
              placeholder={placeholder}
              className={`block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1
          placeholder:text-gray-400
          focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600
          sm:text-sm/6
          ${
                  darkMode
                      ? "bg-darkMainColor text-white"
                      : "bg-white text-gray-900"
              }
          ${required ? (value ? 'outline-green-600 outline-2' : 'outline-red-600 outline-2') : (darkMode ? 'outline-neutral-700' : 'outline-gray-300')}
          ${className}
        `}
          />
      </div>
  );
}
